import { Activity } from '../activity'
import { Item } from '../item'

import { Template } from './template'

export default new Template({
  description: 'Importing data records into the DMS from an Excel workbook',
  id: Template.Id.DmsDataImport,
  name: 'DMS Data Import',
  steps: [
    {
      withoutItems: {
        description: 'Reading in the file so it can be processed',
        name: 'Receiving file',
        type: Activity.Type.RetrievingS3Object,
      },
    },
    {
      withoutItems: {
        description: 'Extracting worksheets from the provided file',
        name: 'Reading the Excel workbook',
        type: Activity.Type.ParsingExcelWorkbook,
      },
    },
    {
      basedOnItems: items => {
        const type = Activity.Type.PuttingDmsRecords
        const steps = items
          .filter(item => item.type === Item.Type.RecordModel)
          .map(item => ({
            description: `Writing ${item.name} records into the DMS`,
            item,
            name: `Importing ${item.name} data`,
            type,
          }))
        return steps.length
          ? steps
          : [
              // Placeholder
              {
                description: 'Writing data records into the DMS',
                item: undefined,
                name: 'Importing data',
                type,
              },
            ]
      },
    },
  ],
})
